import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AppliedVoucher } from 'network/response/ICart';
import useAction from 'hooks/useAction';
import { IAvailablePromotions } from '../components/AvailablePromotions/redux/AvailablePromotions.reducer';
import { applyPromo, removePromo } from '../redux/actions/promo.action';
import TrackerCheckout from 'utils/Tracker.checkout';

const useAvailablePromotionsTabsHook = ({
  availablePromotions,
  appliedPromo,
}: {
  availablePromotions: IAvailablePromotions;
  appliedPromo: AppliedVoucher | null;
}) => {
  const { t } = useTranslation();
  const [applyPromoAction] = useAction(applyPromo);
  const [removePromoAction] = useAction(removePromo);

  const activeTab = availablePromotions.tabData.data[0];

  const onVoucherApply = (code: string) => {
    const applyPromoSuccessCallback = TrackerCheckout.availablePromotionsVoucherApplied.bind(
      null,
      code
    );
    const bindApplyPromoAction = applyPromoAction.bind(null, code, t, applyPromoSuccessCallback);

    // Before applying new voucher we should remove current applied voucher
    if (appliedPromo) {
      removePromoAction(appliedPromo.code, t, bindApplyPromoAction);
    } else {
      bindApplyPromoAction();
    }
  };

  const onToggleCard = (toggleData: { isExpanded: boolean; voucherCode: string }) => {
    TrackerCheckout.availablePromotionsToggleTnC(toggleData);
  };
  useEffect(() => {
    if (activeTab.coupons) {
      const noCouponFound = activeTab.coupons.length === 0;
      TrackerCheckout.availablePromotionsTabClicked(noCouponFound);
    }
  }, [activeTab]);

  return {
    onVoucherApply,
    onToggleCard,
  };
};

export default useAvailablePromotionsTabsHook;
